import React from 'react';

export function AboutUs(): JSX.Element {
  return <h1>About Us!</h1>;
}
